// tslint:disable:max-line-length
import React from 'react';

const MyChartersIcon: React.SFC<{}> = () => (
    <svg viewBox="0 0 100 100">
        <g>
            <path
                fill="currentColor"
                d="M71.4,28.2l-0.3-0.3c-1.2-1.2-1.2-3.1,0-4.3L87.7,7c1.2-1.2,3.1-1.2,4.3,0l0.3,0.3c1.2,1.2,1.2,3.1,0,4.3L75.7,28.2C74.5,29.4,72.5,29.4,71.4,28.2"
            />
            <path
                fill="currentColor"
                d="M35.4,92.3c2.2,2.2,6.1,2.1,8.4-0.3l43.6-46.6c1.1-1.1,1.7-2.8,1.6-4.6c0,0-1-15.7-2.7-22.3c-0.6-2.5-0.8-4-2.1-5.1c-1.1-1-2.5-1-5-1.3c-8-1.1-22.5-1.4-22.5-1.4c-1.8,0.1-3.5,0.6-4.7,2L8.4,59.3c-2.2,2.2-2.1,6.1,0.3,8.4L35.4,92.3z M35,74.1 M20.5,60.4 M80.4,26.2c0,4-3.3,7.3-7.3,7.3c-4,0-7.3-3.2-7.3-7.3c0-4,3.2-7.3,7.3-7.3C77.1,18.9,80.4,22.2,80.4,26.2 M20.5,60.4l28.5-30.6c1.7-1.7,4.6-1.8,6.3-0.1c1.7,1.7,1.8,4.6,0.1,6.3L26.9,66.6c-1.1,1.1-2.5,1.5-4,1.2c-0.6-0.1-1.5-0.5-2-1.1C19.1,65.3,19,62.3,20.5,60.4 M35,74.1l19.4-21c1.7-1.7,4.6-1.8,6.3-0.1c1.7,1.7,1.8,4.6,0.1,6.3l-19.4,21c-1.1,1.1-2.5,1.5-4,1.2c-0.6-0.1-1.5-0.5-2-1.1C33.5,78.7,33.5,76,35,74.1"
            />
        </g>
    </svg>
);
export { MyChartersIcon };
